import { CheckoutDirectDebitConfig } from '../../models/checkout-direct-debit/checkout-direct-debit-config.type';
import { CheckoutDirectDebitMethod } from '../../models/checkout-direct-debit/checkout-direct-debit-method.enum';

export const mockCheckoutDirectDebitConfig: CheckoutDirectDebitConfig = {
  method: CheckoutDirectDebitMethod.AccountNumberSortCode,
};
